import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
const InputDomain = () => {
  const dispatch = useDispatch();
  const [ErrorDomain, setErrorDomain] = useState(false);
  const [Domain, setDomain] = useState();
  const localDomain = localStorage.getItem("domain");
  const domainHandler = () => {
    if (!Domain) {
      setErrorDomain(true);
    } else {
      localStorage.setItem("domain", Domain);
      dispatch({ type: "set", loginProcess: "user" });
    }
  };

  const HandleEnter = (data) => {
    if (data.key === "Enter") {
      domainHandler();
    }
  };

  useEffect(() => {
    if (localDomain) {
      dispatch({ type: "set", loginProcess: "user" });
    }
  });

  return (
    <>
      <div className="my-auto">
        <div className="flex flex-col w-4/5 sm:w-3/5 mx-auto">
          <label className="poppins-800 text-white tracking-lg">
            Domain Account
          </label>
          <input
            onKeyDown={(e) => HandleEnter(e)}
            onChange={(e) => setDomain(e.target.value)}
            className="rounded-lg h-12 my-3 text-center"
          />
          <div className="flex flex-row items-center my-3 mx-auto bg-black bg-opacity-25 p-4 text-white">
            <i className="fa-solid fa-circle-exclamation text-3xl mx-4"></i>
            <p>
              Use your work domain account to ensure the domain, connects with
              existing applications smoothly.
            </p>
          </div>
          <button
            onClick={(e) => domainHandler()}
            className="my-3 text-main-blue text-sm mx-auto w-28 h-10 bg-white rounded-md poppins-800 text-blue-b3 tracking-widest hover:bg-slate-200"
          >
            Next
          </button>
          {ErrorDomain ? (
            <p className="text-red-500 ">
              Domain cannot be empty or less than 5 character please enter valid
              domain.
            </p>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default InputDomain;
